export default __webpack_public_path__ + "static/media/background-05.4626b798.webp";